import { Controller } from "@hotwired/stimulus"

// Provides visual feedback when forms are submitted
// Adds loading state to submit buttons
export default class extends Controller {
  static targets = ["submit"]

  connect() {
    // Handle form submit events
    this.element.addEventListener("submit", this.handleSubmit.bind(this))
  }

  handleSubmit(_event) {
    const submitButton = this.findSubmitButton()
    
    if (submitButton && !submitButton.disabled) {
      // Disable the button to prevent double submission
      submitButton.disabled = true
      
      // Add loading class for styling
      submitButton.classList.add("btn-loading")
      
      // Update button text to show loading state
      const originalText = submitButton.textContent.trim()
      submitButton.dataset.originalText = originalText
      submitButton.innerHTML = '<span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Saving...'
      
      // Store the original button content
      submitButton.dataset.loading = "true"
    }
  }

  findSubmitButton() {
    // Look for submit target first
    if (this.hasSubmitTarget) {
      return this.submitTarget
    }
    
    // Fallback: find submit button in the form
    return this.element.querySelector('button[type="submit"], input[type="submit"], .btn-success[type="submit"]')
  }

  disconnect() {
    this.element.removeEventListener("submit", this.handleSubmit.bind(this))
  }
}

